var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_20033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1435 21.3301L14.7267 19.9133C13.1917 21.1607 11.2342 21.9083 9.10209 21.9083C4.17277 21.9083 0.176758 17.9123 0.176758 12.983C0.176758 8.05363 4.17277 4.05762 9.10209 4.05762C14.0314 4.05762 18.0274 8.05363 18.0274 12.983C18.0274 15.1151 17.2798 17.0725 16.0325 18.6076L17.4492 20.0243L17.8845 19.5891L22.8088 24.5134L20.6325 26.6897L15.7082 21.7653L16.1435 21.3301ZM9.10209 20.0617C13.0116 20.0617 16.1808 16.8924 16.1808 12.983C16.1808 9.07349 13.0116 5.90424 9.10209 5.90424C5.19263 5.90424 2.02338 9.07349 2.02338 12.983C2.02338 16.8924 5.19263 20.0617 9.10209 20.0617Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20917 12.3838H11.6621V14.594H6.20917V12.3838Z",
    fill: "#2E2E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_20033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6321,
    height: 26.2552,
    fill: "white",
    transform: "translate(0.176758 0.43457)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutIcon);
export default __webpack_public_path__ + "static/media/ZoomOutIcon.c26970edf04fb9c54fd9b21a9e1db70c.svg";
export { ForwardRef as ReactComponent };